import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChange } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApplicationViewModel } from 'src/app/_core/models/master/application.model';

@Component({
    selector: 'app-application-dialog',
    templateUrl: './application-dialog.component.html',
    styleUrls: ['./application-dialog.component.scss'],
    standalone: false
})
export class ApplicationDialogComponent implements OnInit {

    @Input() application: ApplicationViewModel;
    @Output() onCloseRequested: EventEmitter<string> = new EventEmitter();

    constructor(
        public sanitizerService: DomSanitizer
    ) { }

    // Properties
    link: string = "";

    @ViewChild('applicationFrame') applicationFrame: ElementRef;

    // Events
    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChange) {
        if (this.application && this.application.linkUrl.toLowerCase() != this.link.toLowerCase()) {
            this.link = this.application.linkUrl;
        }
    }

    // Public methods
    maximize() {
        window.open(this.application.linkUrl);
        this.close();
    }

    close() {
        this.onCloseRequested.emit(this.application.linkUrl);
    }

}
